import React from "react";
import { injectIntl } from "@edx/frontend-platform/i18n";
import { Button, ModalDialog } from "@openedx/paragon";

import { Image } from "@openedx/paragon";
import { getConfig } from "@edx/frontend-platform";
import { isAbsoluteUrl } from "../../../../utils";
import "react-tooltip/dist/react-tooltip.css";
import messages from "../messages";

function ElectiveDetailsModal({
  intl,
  electiveInfo,
  isOpen,
  handleCloseModal,
  handleUpdateElective,
  isElectiveCompleted,
  getIsElectiveSelected,
}) {
  const event = {
    target: {
      name: electiveInfo.subsection,
      checked: !getIsElectiveSelected(electiveInfo),
    },
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      title="Elective"
      size="md"
      onClose={() => handleCloseModal()}
      variant="block"
      isFullscreenOnMobile
      className="elective-modal"
    >
      <ModalDialog.Header>
        <div className="modal-img">
          <Image src={isAbsoluteUrl(electiveInfo.icon) ? electiveInfo.icon : `${getConfig().LMS_BASE_URL}${electiveInfo.icon}`} alt="icon" />
        </div>
        <ModalDialog.Title>{electiveInfo.displayName}</ModalDialog.Title>
      </ModalDialog.Header>
      <ModalDialog.Body>
        {electiveInfo.description}
        <div className="modal-cta d-flex justify-content-center">
          <Button
            variant="outline-primary"
            onClick={() => handleCloseModal()}
          >
            {intl.formatMessage(messages.electiveDialogClose)}
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleCloseModal();
              handleUpdateElective(event, electiveInfo);
            }}
            disabled={isElectiveCompleted}
          >
            {isElectiveCompleted
              ? intl.formatMessage(messages.electiveDialogCompleted)
              : getIsElectiveSelected(electiveInfo)
              ? intl.formatMessage(messages.electiveDialogUnSelect)
              : intl.formatMessage(messages.electiveDialogSelect)}
          </Button>
        </div>
      </ModalDialog.Body>
    </ModalDialog>
  );
}

export default injectIntl(ElectiveDetailsModal);
